
import { defineComponent, PropType } from 'vue'

import { KnowledgeFilterField, KnowledgeFilterOption } from '~/utils/knowledge/types'

export default defineComponent({
  name: 'KnowledgeCombobox',
  props: {
    field: {
      type: Object as PropType<KnowledgeFilterField>,
      required: true
    },
    value: {
      type: Object as PropType<KnowledgeFilterOption | null>,
      default: null
    }
  },
  data() {
    return {
      query: '',
      options: [] as Array<KnowledgeFilterOption>,
      loading: false,
      // Monotonic token: only the latest in-flight search may apply its result.
      requestId: 0
    }
  },
  methods: {
    triggerClasses(isOpen: boolean): string {
      if (this.value) return 'bg-ink-200 hover:bg-ink-100'
      if (isOpen) return 'border-dashed bg-ink-200 text-vanilla-100'
      return 'border-dashed text-vanilla-400 hover:text-vanilla-100'
    },
    async load(query: string): Promise<void> {
      const fetcher = this.field.fetchOptions
      if (!fetcher) return
      const id = ++this.requestId
      this.loading = true
      try {
        const result = await fetcher(query)
        if (id !== this.requestId) return
        this.options = result
      } catch (e) {
        if (id === this.requestId) this.options = []
        this.$logErrorAndToast(e as Error, 'Failed to search repositories.')
      } finally {
        if (id === this.requestId) this.loading = false
      }
    },
    onSearch(raw: string): void {
      this.query = raw
      this.load(raw.trim())
    },
    onSelect(opt: KnowledgeFilterOption, close: () => void): void {
      this.$emit('change', opt)
      close()
    },
    onReset(): void {
      this.$emit('change', null)
    },
    onMenuToggle(open: boolean): void {
      if (open) {
        this.query = ''
        this.load('')
      }
    }
  }
})
